module.exports = __webpack_public_path__ + "static/media/preloader2.c863daf9.gif";